import { forwardRef } from "react";
import { Legend as RELegend } from "recharts";

import PropTypes from "prop-types";
import { LegendContainer } from "./Legend.styles";

export const LegendContent = ({ payload }) => (
  <LegendContainer>
    {payload.map((entry, i) => (
      <li key={i}>
        <span
          className="line"
          style={{ backgroundColor: entry.payload.stroke }}
        ></span>
        <span className="name"> {entry.value}</span>
      </li>
    ))}
  </LegendContainer>
);

LegendContent.propTypes = {
  payload: PropTypes.array,
};

export const Legend = forwardRef((props, ref) => {
  return <RELegend content={LegendContent} {...props} ref={ref} />;
});

Legend.displayName = "Legend";
